import { useEffect, useRef } from 'react';
import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { Container } from './Container';
import { ContainerProps, DndProps } from '../types';
import { animateLayoutChanges } from '../utils';

interface DropableContainerProps extends ContainerProps {
  disabled?: boolean;
  id: UniqueIdentifier;
  items: UniqueIdentifier[];
}

export function DroppableContainer({
  // children = null,
  disabled,
  id,
  items,
  render,
  ...props
}: Readonly<DropableContainerProps>) {
  const {
    active,
    attributes,
    isDragging,
    listeners,
    over,
    setNodeRef,
    // transition,
    // transform,
  } = useSortable({
    id,
    data: {
      type: 'container',
      children: items,
    },
    animateLayoutChanges,
  });

  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (ref) setNodeRef(ref.current);
  }, [ref]);

  const isOverContainer = over
    ? (id === over.id && active?.data.current?.type !== 'container') ||
      items.includes(over.id)
    : false;

  return (
    <Container
      ref={ref}
      isHover={isOverContainer}
      handleProps={{
        attributes,
        listeners,
      }}
      render={() => {
        return render?.({
          attributes,
          disabled,
          dragging: isDragging,
          isHover: isOverContainer,
          listeners,
        } as DndProps);
      }}
      {...props}
    />
  );
}
